<template>
  <div>
    <hr />
    <div class="row">
      <div class="col-12 bg-secondaryL p-3 my-auto">
        <h4 class="d-inline">Contract Info</h4>
        <a href="#" @click="refreshTransfer">
          <img
            src="@/assets/img/refresh_icon.png"
            class="my-auto float-right d-inline"
            alt="Refesh Icon"
          />
        </a>
      </div>
    </div>
    <div class="row pt-3 pb-4">
      <div class="col-sm-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-12">
            <label for="serviceBundle" class="font-weight-bold text-left pl-2">
              Service Bundle
              <span v-if="!$v.serviceBundle.required">*</span>
            </label>
          </div>
          <div class="col-12">
            <div class="btn-group d-block w-100">
              <div class="form-group my-auto">
                <!-- <b-form-select id="serviceBundle" v-model="serviceBundle"  class="form-control" :class="{ 'is-invalid': $v.serviceBundle.$error }">
                                <option v-for="(bundle, index) in serviceBundleList" :key="index" :value="bundle">{{bundle.ServiceBundleName}}</option>
                              </b-form-select>
                <div v-if="!$v.serviceBundle.required" class="invalid-feedback">Please select a service bundle.</div>-->

                <div class="col-12">
                  <div class="input-group" v-if="!serviceBundle">
                    <input
                      v-model="serviceBundleSearch"
                      @keyup="search()"
                      @paste="search($event)"
                      type="text"
                      class="form-control underline"
                      name="Search for a bundle"
                      placeholder="Please start typing....."
                      pattern="^[A-Za-z\s-]+$"
                    />
                  </div>
                  <div class="col no-pad bg-white sfab-search-results">
                  <div
                    class="row"
                    v-if="(results && (results.length === 0 || !results)) && serviceBundleSearch && serviceBundleSearch.length > 0"
                  >
                    <div class="col-12">
                      <div class="mx-auto p-3">
                        <h5>Search Results:</h5>
                        <p class="d-inline">Sorry, no results found. Please try again.</p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-else-if="results && results.length >= 1 && serviceBundleSearch.length > 2"
                  >
                    <div class="col-sm">
                      <div class="mx-auto p-3">
                        <b-list-group>
                          <b-list-group-item
                            href="#"
                            @click="selectServiceBundle(result.Document)"
                            v-for="(result, rIndex) in results"
                            :key="rIndex"
                          >{{result.Document.ServiceBundleName}}</b-list-group-item>
                        </b-list-group>
                      </div>
                    </div>
                  </div>
                </div>
                  <!-- This button only appears when a bundle has been selected -->
                  <div class="d-flex align-items-end flex-column h-100" v-if="serviceBundle">
                    <template>
                      <b-table
                        responsive
                        outlined
                        striped
                        :items="[serviceBundle]"
                        :fields="searchResultFields"
                      >
                        <template slot="name" slot-scope="data">{{data.item.ServiceBundleName}}</template>
                        <template slot="description" slot-scope="data">{{data.item.ServiceBundleDescription}}</template>
                        <template slot="action">
                          <a href="#" onclick="return false;" @click="clearSelection">
                            <img src="@/assets/img/remove_icon.png" />
                          </a>
                        </template>
                      </b-table>
                    </template>
                  </div>
                  <!-- This is where the search results start -->
                  <!-- <div class="col no-pad bg-white sfab-search-results" v-else>
                    <div
                      class="row"
                      v-if="(serviceBundleResults.length == 0 || !serviceBundleResults) && serviceBundleSearch.length > 0"
                    >
                      <div class="col-12">
                        <div class="mx-auto p-3">
                          <h5>Search Results:</h5>
                          <p class="d-inline">Sorry, no results found. Please try again.</p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-else-if="serviceBundleResults && serviceBundleResults.length >= 1 && serviceBundleSearch.length > 2"
                    >
                      <div class="col-sm">
                        <div class="mx-auto p-3">
                          <template>
                            <b-list-group>
                              <b-list-group-item
                                href="#"
                                @click="selectServiceBundle(result.Document)"
                                v-for="(result, rIndex) in serviceBundleResults"
                                :key="rIndex"
                              >{{result.Document.ServiceBundleName}}</b-list-group-item>
                            </b-list-group>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- This is where the search results end -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- left col 4 close -->
      <div class="col-sm-6 col-xl-4">
        <div class="row">
          <div class="col-sm-12">
            <label
              for="contractStartDate"
              class="font-weight-bold text-left pl-2"
            >Contract Start Date</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div>
              <!-- This datepicker needs to default to the transfer date which was chosen on screen 1 -->
              <el-date-picker
                id="contractStartDate"
                v-model="contractStartDate"
                readonly
                format="dd.MM.yyyy"
                value-format="yyyy-MM-dd"
                class="float-right"
                type="date"
                placeholder="Select start date"
              ></el-date-picker>
              <!-- <div class="error" v-if="!$v.contractStartDate.required">* Required</div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- middle row col 4 close -->

      <div class="col-sm-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-sm-12">
            <label for="contractTerm" class="font-weight-bold text-left pl-2">
              Contract Term
              <span v-if="!$v.contractTerm.required">*</span>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="input-group">
              <!-- <input type="number" step="1" class="form-control" v-model="contractTerm" placeholder="Enter number of years" aria-label="Number of years" aria-describedby="years_field"> -->
              <b-form-input
                id="contractTerm"
                type="number"
                step="1"
                class="form-control"
                v-model="contractTerm"
                placeholder="Enter number of years"
                aria-label="Number of years"
                aria-describedby="years_field"
                :class="{ 'is-invalid': $v.contractTerm.$error }"
              />
              <div class="input-group-append">
                <span class="input-group-text" id="years_field">Years</span>
              </div>
              <div
                v-if="!$v.contractTerm.required"
                class="invalid-feedback"
              >Please provide a contract term.</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-6 col-xl-4">
        <div class="row">
          <div class="col-sm-12">
            <label for="contractType" class="font-weight-bold text-left pl-2">
              Contract Type
              <span v-if="!$v.contractType.required">*</span>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="input-group">
              <b-form-select
              id="contractType"
              class="form-control"
              v-model="contractType"
              :options="[
                  { value: 'Agreed', text: 'Agreed' },
                  { value: 'Deemed', text: 'Deemed' },
                ]"
              >
            </b-form-select>
              <div
                v-if="!$v.contractType.required"
                class="invalid-feedback"
              >Please provide a contract term.</div>
            </div>
          </div>
        </div>
      </div>
      <!-- righ row col 4 close -->
    </div>
    <!-- sb row close -->
    <div class="modal-footer">
      <div class="row">
        <div class="col-12">
          <button type="submit" class="btn btn-hc float-left mr-2" @click="back">
            <i class="fas fa-caret-left"></i> Back
          </button>
          <button
            type="submit"
            class="btn btn-hc float-right ml-2"
            @click="next"
            :disabled="!serviceBundle || !contractTerm"
          >
            Next
            <i class="fas fa-caret-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import _ from 'underscore';
// import Swal from 'sweetalert2'

export default {
	data() {
		return {
			searchResultFields: {
				name: {
					key: 'ServiceBundleName',
					label: 'Service Bundle',
					class: 'text-center',
				},
				description: {
					key: 'ServiceBundleDescription',
					label: 'Description',
					class: 'text-center',
				},
				action: {
					label: '',
					class: 'text-center',
				},
			},
		};
	},
	validations() {
		return {
			serviceBundle: {
				required,
			},
			contractTerm: {
				required,
			},
			contractType: {
				required,
			},
		};
	},
	methods: {
		refreshTransfer() {
			this.$store.commit('refreshTransfer');
			this.$store.commit('resetServiceBundleResults');
		},
		next() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.$emit('next');
			}
		},
		back() {
			this.$emit('back');
		},
		search() {
			this.$store.dispatch('serviceBundleSearch', {
				Criteria: this.serviceBundleSearch,
				Index: 'Transfer',
			});
		},
		selectServiceBundle(serviceBundle) {
			this.$store.commit('resetServiceBundleResults');
			this.serviceBundleSearch = null;
			this.serviceBundle = serviceBundle;
			this.$store.dispatch(
				'getCompleteServiceBundle',
				serviceBundle.ServiceBundleId
			);
		},
		clearSelection() {
			this.serviceBundle = null;
			this.serviceBundleSearch = '';
		},
		checkCompatibility(serviceBundleTypes) {
			let isCompatible = true;
			this.serviceTypes.forEach((serviceType) => {
				isCompatible = serviceBundleTypes.includes(serviceType)
					? isCompatible
					: false;
			});

			return isCompatible;
		},

		validateTariff() {
			if (
				!this.completeServiceBundle ||
				!this.completeServiceBundle.TariffVersions
			) {
				throw new Error(
					'Service bundle or its tariff versions are not available.'
				);
			}

			const version = this.completeServiceBundle.TariffVersions.find((v) =>
				moment(this.transferDate).isBetween(
					v.EffectiveFrom,
					v.EffectiveTo || '9999-12-31',
					'D',
					'[]'
				)
			);

			if (!version) {
				throw new Error('No valid tariff version found for the selected date.');
			}

			if (
				this.serviceTypes.includes('Electricity') &&
				(!version.NhhElectricityDetails ||
					!version.NhhElectricityDetails.length) &&
				(!version.HhElectricityDetails || !version.HhElectricityDetails.length)
			)
				throw new Error(
					'Tariff does not support selected electricity services'
				);
			if (
				this.serviceTypes.includes('Gas') &&
				(!version.GasDetails || !version.GasDetails.length)
			)
				throw new Error('Tariff does not support selected gas services');

			return version;
		},
	},
	computed: {
		serviceBundleSearch: {
			get() {
				return this.$store.state.transfer.transferServiceBundleSearch;
			},
			set(search) {
				this.$store.commit('updateTransferServiceBundleSearch', search);
				this.search(search);
			},
		},
		results: {
			get() {
				// return this.$store.state.serviceBundleResults;
				let that = this;

				// Filtering returned search for service bundles that are relevent to the selected services
				return this.$_.filter(this.$store.state.serviceBundleResults, function(
					transferSearch
				) {
					return that.checkCompatibility(transferSearch.Document.ServiceTypes);
				});
			},
			set(results) {
				this.$store.commit('updateServiceBundleResults', {
					Results: results,
					Index: 'Transfer',
				});
			},
		},
		transferDate() {
			return this.$store.state.transfer.transferDate;
		},
		serviceBundle: {
			get() {
				return this.$store.state.transfer.serviceBundle;
			},
			set(serviceBundle) {
				this.$store.commit('updateServiceBundle', serviceBundle);
			},
		},
		contractStartDate: {
			get() {
				return this.$store.state.transfer.contractStartDate;
			},
			set(date) {
				this.$store.commit(
					'updateContractStartDate',
					moment.utc(date).format()
				);
			},
		},
		contractTerm: {
			get() {
				return this.$store.state.transfer.contractTerm;
			},
			set(term) {
				this.$store.commit('updateContractTerm', term);
			},
		},
		contractType: {
			get() {
				return this.$store.state.transfer.contractType;
			},
			set(contractType) {
				this.$store.commit('updateContractType', contractType);
			},
		},
		transferServices: {
			get() {
				return this.$store.state.transfer.transferServices;
			},
			set(details) {
				this.$store.commit('updateServiceDetails', details);
			},
		},
		serviceTypes() {
			let serviceTypes = [];
			this.transferServices.forEach((service) => {
				serviceTypes.push(service.Service.ServiceType);
			});
			return _.uniq(serviceTypes);
		},
		completeServiceBundle() {
			return this.$store.state.completeServiceBundle;
		},
	},
};
</script>
